import { config } from '@services/config';
import { BrokerageGetRequestQuery, BrokerageSearchResponse } from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage';
import { BrokerageItems } from '@services/brokerage/brokerage.types';
import { getBrokeragesQuery } from '@services/brokerage/brokerage.helpers';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchBrokerages = (params: BrokerageGetRequestQuery) => {
  const client = useClient();
  const query = getBrokeragesQuery(params);
  const result = useQuery({
    queryKey: brokerageKeys.searchWithParams(params),
    queryFn: () => client.get(`brokerage?${query}`).json<BrokerageSearchResponse>(),
    ...config,
  });

  return { ...result, brokerages: result.data };
};

export const useBrokerages = ({ enabled = true, sort }: { enabled?: boolean; sort?: string }) => {
  const client = useClient();
  const queryParams = new URLSearchParams();
  queryParams.append('pageLimit', '1000');

  if (sort) {
    queryParams.append('sort', sort);
  }

  const result = useQuery<BrokerageItems, Error>({
    queryKey: brokerageKeys.brokerages,
    queryFn: async () => {
      const response = await client.get(`brokerage?${queryParams}`).json<BrokerageSearchResponse>();
      return response.items;
    },
    enabled,
    ...config,
  });
  return { ...result, brokerages: result.data || [] };
};
